import BatchesReportContainer from "@/Reports/BatchesReportContainer.vue";

export default [
  {
    path: "/accounting/batches",
    name: "BatchesReportContainer",
    component: BatchesReportContainer,
    meta: {
      permissionRoles: ["financial_data"]
    }
  }
];
